import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { ZONE_SELECTION, DEFAULT_NUM_ZONES } from 'manual/constants';
import { useAppSelector } from 'app/hooks';
import { getGenerateZonesReviewSubtitle } from './selectors';

// Components
import { Spinner, Card, Dropdown } from '@tcc/crate';
import ZoneTable from 'manual/ZoneTable';
import ReviewGeneratedZonesMapContainer from 'mapping/ReviewGeneratedZonesMapContainer';

const ZoneGenerationReview = ({
  areMapLayersLoaded,
  zoneRows,
  fetchMapZones,
}) => {
  useEffect(() => {
    fetchMapZones();
  }, [fetchMapZones]);

  const [numZonesSelected, setNumZonesSelected] = useState(DEFAULT_NUM_ZONES);
  const [rowHover, setRowHover] = useState('');
  const header = getMessage(
    'title-text__create-manualv2-generate-zones--review-header',
  );
  const subtitle = useAppSelector(getGenerateZonesReviewSubtitle);
  const baseString = 'vra-zone-generation-review';
  const classString = classNames({
    [`${baseString}`]: true,
    [`vra-create-script-screen`]: true,
  });

  return (
    <section className={classString}>
      {areMapLayersLoaded ? (
        <>
          <section className={`${baseString}__header`}>
            <p>{header}</p>
            <p className={`${baseString}__header__map-type`}>{subtitle}</p>
          </section>
          <Card className="vra-zone-generation-summary">
            <section className="vra-zone-generation-summary__data">
              <div className="vra-zone-generation-summary__data__zone-selection">
                <div>{getMessage('label-text__num-zones')}</div>
                <Dropdown
                  className="vra-zone-generation-summary__data__zone-selection__selector"
                  options={ZONE_SELECTION}
                  setValue={(numZonesSelected) => {
                    fetchMapZones(numZonesSelected);
                    setNumZonesSelected(numZonesSelected);
                  }}
                  value={numZonesSelected}
                />
              </div>
              <ZoneTable
                rowHover={rowHover}
                rows={zoneRows}
                setRowHover={setRowHover}
              />
            </section>
            <ReviewGeneratedZonesMapContainer rowHover={rowHover} />
          </Card>
        </>
      ) : (
        <Spinner className="vra-management-zones-container-spinner" size="24" />
      )}
    </section>
  );
};

ZoneGenerationReview.propTypes = {
  areMapLayersLoaded: propTypes.bool.isRequired,
  fetchMapZones: propTypes.func.isRequired,
  mapLayer: propTypes.object.isRequired,
  zoneRows: propTypes.array.isRequired,
};

export default ZoneGenerationReview;
